<script lang="ts">
  let { label, count, accent, textColor, first = false }: { label: string; count: number; accent: string; textColor: string; first?: boolean } = $props();
</script>

<div class:first class="section-label">
  <h2>{label}</h2>
  <span style={`--badge:${accent};--badge-text:${textColor}`} aria-label={`${count} ${label.toLowerCase()}`}>{count}</span>
</div>
